<template>
  <div class="step-wrap">
    <template v-for="(item, index) in steps">
      <div class="step-item" :key="index">
        <span class="number" :class="{ active: index < active }">{{ index + 1 }}</span>
        <p class="title" :class="{ active: index < active }">{{ item }}</p>
      </div>
      <div
        class="line"
        :class="{ active: index + 1 < active }"
        :key="item + index"
        v-if="index < steps.length - 1"
      ></div>
    </template>
  </div>
</template>

<script>
export default {
  name: 'z-step',
  props: {
    active: {
      type: Number,
      default: 1,
    },
    steps: {
      type: Array,
      default: () => [],
    },
  },
}
</script>

<style scoped lang="scss">
.step-wrap {
  display: flex;
  justify-content: space-between;
  align-items: center;
  .step-item {
    display: flex;
    align-items: center;
    .number {
      width: 20px;
      height: 20px;
      text-align: center;
      line-height: 20px;
      border-radius: 50%;
      background: #999999;
      color: #fff;
      font-size: 12px;
      margin-right: 4px;
      &.active {
        background: #0560fd;
      }
    }
    .title {
      font-size: 14px;
      color: #999999;
      &.active {
        color: #0560fd;
      }
    }
  }
  .line {
    flex: 1;
    background: #e5e5e5;
    height: 1px;
    margin: 0 10px;
    &.active {
      background: #0560fd;
    }
  }
}
</style>
